import { AppointmentQualificationStatus } from '@agent/core/contact/appointment-deprecated.service';
import { IAppointment } from '@commons/models/appointment';

import { Option, QualifField, QualificationService } from '@contact/upgrade';

export enum AttemptStatus {
  /**
   * The agent received an automatic response (answer machine for example).
   * <p>A cascading will be performed, if the campaign requires it and there is another phone number. Otherwise, this contact will be presented for a new Attempt</p>
   */
  ANSWERPHONE_BY_AGENT,
  /**
   * An automatic response (answer machine for example) has been automatically detected. This contact will be presented for a new Attempt
   * <p>A cascading will be performed, if the campaign requires it and there is another phone number. Otherwise, this contact will be presented for a new Attempt</p>
   */
  ANSWERPHONE_BY_SCRIPT,
  /**
   * A message has been left on answering machine
   *
   */
  ANSWERPHONE_MESSAGE,
  /**
   * The Booking has been correctly treated, this contact attempt is considered as the last one for this Campaign
   */
  HANDLED,
  /**
   * The contact was busy
   */
  BUSY,
  /**
   * The contact did not answer
   */
  NO_ANSWER,
  /**
   * Information used to made the contact attempt are incorrect (bad number, bad email, etc.)
   */
  INCORRECT,
  /**
   * The External Component in charge of treating the Booking Attempt did not processed the contact. For example with Booking solution,
   * the media controller did not processed the Booking attempt
   */
  TOCALL,
  /**
   * The contact has an invalid value for one of the following information :
   * <ul>
   * <li>Stream UUID</li>
   * <li>Skill(s) UUID</li>
   * </ul>
   */
  BAD_CONFIGURATION,
  /**
   * The contact has been contacted, but we have to re-contact later
   */
  TORECALL,
  /**
   * A fax has been detected
   */
  FAX,
  /**
   * the contact phone is not authorized by the media forbidden numbers regex, it will not be presented anymore
   */
  FORBIDDEN,
  /**
   * The phone number is not associated to the contact but to another person. Do not dial this number again.
   */
  WRONG_NUMBER,
  /**
   * The contact has asked not to be called anymore.
   */
  LEAVE_ME_ALONE,
  /**
   * The contact has been qualified and closed by a CSR without call to be done
   */
  MANUALLY_CLOSED,
  /**
   * The contact has been qualified and canceled by a CSR without call to be done
   */
  MANUALLY_CANCELED,
}

export class PostContactDataDto {
  idField: string;
  inputValue: string;
}

export class ContactAttemptDto {
  uri: string;
  status: AttemptStatus;
  startDate: Date;
  enDate: Date;
}

export class PostContactReportDto {
  idContact: string;
  startDate: Date;
  endDate: Date;
  rescheduleReason: string;
  rescheduleDate: Date;
  phoneNumber: string;
  idCsr: string;
  csrLogin: string;
  csrToAssign: string;
  formFilled: boolean;
  reportSender: string;
  origin: string;
  appointment: IAppointment;
  skillListUuid: string[];
  status: AttemptStatus;
  formValues: PostContactDataDto[];
  action: string;

  static toDto(
    status: AppointmentQualificationStatus,
    appointment: IAppointment,
    fields: QualifField[],
    idCsr: string,
    csrLogin: string,
    skillListUuid: string[],
    origin: string,
    action: string
  ): PostContactReportDto {
    return {
      idContact: appointment.idContact,
      startDate: new Date(),
      endDate: new Date(),
      rescheduleReason: '',
      rescheduleDate: new Date(),
      phoneNumber: appointment.phone,
      idCsr: idCsr,
      csrLogin: csrLogin,
      csrToAssign: '',
      formFilled: true,
      reportSender: 'CSR',
      appointment: appointment,
      status: status === AppointmentQualificationStatus.SUCCESS ? AttemptStatus.MANUALLY_CLOSED : AttemptStatus.MANUALLY_CANCELED,
      formValues: PostContactReportDto.computeFormValues(fields),
      skillListUuid: skillListUuid,
      origin: origin,
      action: action,
    };
  }

  private static computeFormValues(fields: QualifField[]): PostContactDataDto[] {
    let result: PostContactDataDto[] = [];
    fields.forEach(f => {
      if (f.controlType === 'input') {
        result.push({
          idField: f.id,
          inputValue: Option.of(f.value as string).getOrElse(''),
        });
      } else if (f.value && QualificationService.isFieldSelect(f.value)) {
        result.push({
          idField: f.id,
          inputValue: Option.of(f.value.value).getOrElse(''),
        });
      }
    });
    return result;
  }
}
